import axios from "axios";
import PageParams from "../interfaces/pageParams";
import { BASE_URL } from "../util/constants";
import PagedResult from "../interfaces/pagedResult";
import User from "../interfaces/user";

const UseApiUser = () => {
    const axiosInstance = axios.create({
        baseURL: BASE_URL,
    });

    const pagedUser = (pageParams: PageParams) => {
        return axiosInstance
        .get<PagedResult<User>>("/users/paged", { params: pageParams })
        .then(res => res.data)
        .catch((err) => {
            handleError(err);
            throw err;
        });
    }

    const handleError = (err: any) => {
        console.log("Error occurred: ", err);

        if (err.response) {
        console.log("Requisition returned with error:");
        console.log("Response: ", err.response.data);
        console.log("Status: ", err.response.status);
        } else if (err.request && err.config) {
        console.log("Requisition was done but didn't had server answer:");
        console.log("URL: ", err.config.baseURL);
        console.log("Method: ", err.config.method);
        console.log("URL requested: ", err.config.url);
        } else {
        console.log("Error message: ", err.message);
        }
    };

    return { pagedUser };
}

export default UseApiUser;